export default {"src":"/_next/static/media/payment-giropay.fc34b6fe.svg","height":16,"width":24,"blurWidth":0,"blurHeight":0};